import api from '@/helpers/api';
import * as Sentry from '@sentry/browser';

let contactCacheResync;

export default {
  resetOrganisationContacts({ commit }) {
    commit('RESET_ORGANISATION_CONTACTS');
  },
  updateContactCache({ commit }, payload) {
    commit('UPDATE_CONTACT_CACHE', payload);
  },
  fetchOrganisationContacts({ commit, getters, rootState }, payload) {
    commit('API_ERROR', '');
    if (!payload.data.search_query && payload.data.page === 1 && payload.data && payload.data.conversations_business && getters.contactCache[payload.data.conversations_business] && getters.contactCache[payload.data.conversations_business].data) {
      commit('RESET_ORGANISATION_CONTACTS');
      commit('SET_ORGANISATION_CONTACTS', { ...getters.contactCache[payload.data.conversations_business] });
      return;
    }
    commit('SET_LOADING_ORGANISATION_CONTACTS', true);
    api('GET', `/organisation/${payload.organisationId}/contacts`, payload.data, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('SET_ORGANISATION_CONTACTS', response.data);
          if (!payload.data.search_query && payload.data.page === 1) {
            commit('UPDATE_CONTACT_CACHE', { data: response.data, numberId: payload.data.conversations_business });
          }
        }
        commit('SET_LOADING_ORGANISATION_CONTACTS', false);
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
        commit('SET_LOADING_ORGANISATION_CONTACTS', false);
        Sentry.captureException(`Start conversation (ORG: ${rootState.organisation.currentOrganisation.name}, USER: ${rootState.user.email}) - ${JSON.stringify(error.response)}`);
      });
  },
  resyncContactCache({ commit, rootState, dispatch }) {
    commit('CLEAR_CONTACT_CACHE');
    if (rootState.chat.activeConversation && rootState.chat.activeConversation.business_id) {
      clearTimeout(contactCacheResync);
      contactCacheResync = setTimeout(() => {
        dispatch('fetchOrganisationContacts', {
          organisationId: rootState.organisation.currentOrganisation.id,
          data: {
            conversations_business: rootState.chat.activeConversation.business_id,
            limit: 50,
            page: 1,
          },
        });
      }, 3000);
    }
  },
  clearContactCache({ commit }) {
    commit('CLEAR_CONTACT_CACHE');
  },
  // TODO this should go to special api class which doesn't handle any mutation.
  getContactsForOrganisation(_, payload) {
    return api('GET', `/organisation/${payload.organisationId}/contacts`, payload.data, null, 'w');
  },
  fetchOrganisationContactsPage({ commit }, payload) {
    commit('START_LOADING_CONTACTS');
    commit('SET_ORGANISATION_CONTACTS_PAGE_LOADING', true);
    api('GET', `/organisation/${payload.organisationId}/contacts`, payload.data, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('SET_ORGANISATION_CONTACTS_PAGE_LIST', response.data);
          // testing below, removeme!!!!
          // commit('SET_ORGANISATION_CONTACTS_PAGE_LIST', { data: [], links: {}, meta: {} });
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      })
      .finally(() => {
        commit('SET_ORGANISATION_CONTACTS_PAGE_LOADING', false);
        commit('END_LOADING_CONTACTS');
      });
  },
  fetchContacts({ commit }, payload) {
    commit('START_LOADING_CONTACTS');
    api('GET', `/organisation/${payload.organisationId}/contacts`, payload.data, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('SET_CONTACTS', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      })
      .finally(() => {
        commit('END_LOADING_CONTACTS');
      });
  },
  fetchSubscribers({ commit }, payload) {
    commit('START_LOADING_SUBSCRIBERS');
    api('GET', `/merchants/${payload.merchant_id}/subscribers`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_SUBSCRIBERS', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  fetchConversationContacts({ commit }, payload) {
    commit('START_LOADING_CONVERSATION_CONTACTS');
    api('GET', `/merchants/${payload.merchant_id}/conversation-contacts`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_CONVERSATION_CONTACTS', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  fetchContact({ commit, rootState, rootGetters }, payload) {
    commit('START_LOADING_CONTACT');
    const me = rootGetters['organisation/me'];
    const request = api('GET', `organisation/${rootState.organisation.currentOrganisation.id}/contacts/${payload.contact_id}`, { _: process.env.VUE_APP_VERSION, __: me.platform_id, ____: window.todesktop ? 'd' : 'w' }, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit('SET_CONTACT', response.data);
        }
      })
      .catch((error) => {
        commit('END_LOADING_CONTACT');
        commit('API_ERROR', error.response);
      });
    return request;
  },
  fetchActivities({ commit }, payload) {
    commit('START_LOADING_ACTIVITIES');
    api('GET', `/merchants/${payload.merchant_id}/contacts/${payload.contact_id}/activities`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_ACTIVITIES', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  createContact({ commit, dispatch }, payload) {
    // POST w/organisation/<str:organisation_uid>/contacts
    // payload.data: string name, string phone, array business_uids
    return new Promise((resolve, reject) => {
      api('POST', `organisation/${payload.organisationId}/contacts`, payload.data, null, 'w')
        .then((response) => {
          if (response.status === 200) {
            resolve(response);
            dispatch('resyncContactCache');
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          commit('API_ERROR', error.response);
          reject(error.response);
        });
    });
  },
  updateContact({ commit }, payload) {
    api('PUT', `organisation/${payload.organisationId}/contacts/${payload.contact_id}`, payload.data, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('CONTACT_UPDATED', payload.contact_id);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  deleteContacts({ commit }, payload) {
    // commit('CONTACT_DELETED', false);
    // api('DELETE', `/merchants/${payload.merchant_id}/contacts`, payload.data)
    //   .then((response) => {
    //     if (response.status === 200) {
    //       commit('CONTACT_DELETED', payload.data);
    //     }
    //   })
    //   .catch((error) => {
    //     commit('API_ERROR', error.response);
    //   });
    const request = api('DELETE', `organisation/${payload.organisationId}/contacts`, payload.data, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit('REMOVE_CONTACT_FROM_CACHE', payload.data.contact_ids);
        }
      });
    return request;
  },
  fetchContactTags({ commit }, payload) {
    console.error('deprecated contact/fetchContactTags, use contact_tags instead');
    commit('START_LOADING_CONTACT_TAGS', true);
    api('GET', `/merchants/${payload.merchantId}/contact-tags`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_CONTACT_TAGS', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  createContactTag({ commit }, payload) {
    console.error('deprecated contact/createContactTag, use contact_tags instead');
    commit('CONTACT_TAG_CREATED', false);
    api('POST', `/merchants/${payload.merchant_id}/contact-tags`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('CONTACT_TAG_CREATED', response.data.tag);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  updateContactTag({ commit }, payload) {
    console.error('deprecated contact/updateContactTag, use contact_tags instead');
    commit('CONTACT_TAG_UPDATED', false);
    api('PUT', `/merchants/${payload.merchant_id}/contact-tags/${payload.tag_id}`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('CONTACT_TAG_UPDATED', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  deleteContactTag({ commit }, payload) {
    console.error('deprecated contact/deleteContactTag, use contact_tags instead');
    commit('CONTACT_TAG_DELETED', false);
    api('DELETE', `/merchants/${payload.merchant_id}/contact-tags/${payload.tag_id}`)
      .then((response) => {
        if (response.status === 200) {
          commit('CONTACT_TAG_DELETED', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  syncContactTags({ commit }, payload) {
    console.error('deprecated contact/syncContactTags, use contact_tags instead');
    api('PUT', `/merchants/${payload.merchant_id}/contacts/${payload.contact_id}/sync-tags`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('CONTACT_TAGS_SYNCED', payload.contact_id);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },

  // DEPRECATED
  fetchCustomFields({ commit }, merchantId) {
    commit('START_LOADING_CUSTOM_FIELDS', true);
    api('GET', `/merchants/${merchantId}/contact-fields`)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_CUSTOM_FIELDS', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  fetchCustomFields20({ commit, rootState }) {
    commit('START_LOADING_CUSTOM_FIELDS', true);
    return api('GET', `organisation/${rootState.organisation.currentOrganisation.id}/contact-fields`, null, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('SET_CUSTOM_FIELDS', {
            organisationId: rootState.organisation.currentOrganisation.id,
            data: response.data,
          });
        }
        return response;
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  createCustomField({ commit, rootState }, payload) {
    commit('CUSTOM_FIELD_SAVED', false);
    return api('POST', `organisation/${rootState.organisation.currentOrganisation.id}/contact-fields`, payload.data, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('CUSTOM_FIELD_SAVED', true);
          commit('UPDATE_CONTACT_FIELDS_LIST', { field: response.data.field, organisationId: rootState.organisation.currentOrganisation.id });
        }
        return response;
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  updateCustomField({ commit, rootState }, payload) {
    commit('CUSTOM_FIELD_SAVED', false);
    return api('PUT', `organisation/${rootState.organisation.currentOrganisation.id}/contact-fields/${payload.contactFieldId}`, payload.data, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('CUSTOM_FIELD_SAVED', true);
          commit('UPDATE_CONTACT_FIELDS', { field: response.data.field, organisationId: rootState.organisation.currentOrganisation.id });
        }
        return response;
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  deleteCustomField({ commit, rootState }, payload) {
    commit('CUSTOM_FIELD_DELETED', false);
    return api('DELETE', `organisation/${rootState.organisation.currentOrganisation.id}/contact-fields/${payload.contactFieldId}`, null, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('CUSTOM_FIELD_DELETED', true);
          commit('REMOVE_CUSTOM_FIELD', { contactFieldId: payload.contactFieldId, organisationId: rootState.organisation.currentOrganisation.id });
        }
        return response;
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  addCustomField({ commit, rootState }, payload) {
    commit('ADD_CUSTOM_FIELD', {
      organisationId: rootState.organisation.currentOrganisation.id,
      data: payload,
    });
  },
  deleteSingleCustomField({ commit, rootState }, customFieldId) {
    commit('DELETE_SINGLE_CUSTOM_FIELD', {
      organisationId: rootState.organisation.currentOrganisation.id,
      customFieldId,
    });
  },
  deletedCustomField({ commit }, payload) {
    commit('CUSTOM_FIELD_CHANGED', { oldName: payload.custom_field_name });
  },
  editCustomField({ commit, rootState }, payload) {
    commit('EDIT_CUSTOM_FIELD', {
      organisationId: rootState.organisation.currentOrganisation.id,
      data: payload,
    });
    commit('CUSTOM_FIELD_CHANGED', { name: payload.name, oldName: payload.old_field_name });
  },
  syncContactCustomFields({ commit }, payload) {
    api('PUT', `organisation/${payload.organisationId}/contacts/${payload.contact_id}/sync-custom-fields`, payload.data, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('CUSTOM_FIELDS_SYNCED', payload.contact_id);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  syncContactNotes({ commit }, payload) {
    api('PUT', `organisation/${payload.organisationId}/contacts/${payload.contact_id}/sync-notes`, payload.data, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('CONTACT_NOTES_SYNCED', payload.contact_id);
          commit('SET_CONTACT_NOTES', payload.data.notes);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  uploadContactsFile({ commit }, payload) {
    api(
      'POST',
      `/merchants/${payload.merchant_id}/import-contacts`,
      payload.data,
    )
      .then((response) => {
        if (response.status === 200) {
          commit('SET_IMPORT_ID', response.data.import_id);
        }
      })
      .catch((error) => {
        commit('SET_IMPORT_ERROR', error.response.data.message);
        commit('API_ERROR', error.response);
      });
  },
  clearImportErrors({ commit }) {
    commit('SET_IMPORT_ERROR', '');
  },
  /**
   * Retrieves the unique contacts list calculated from input contacts and tags which may overlap.
   * @param {merchantId: string, tags: Array, contacts: Array} payload
   */
  countUniqueContacts({ commit }, payload) {
    commit('START_CALCULATING_UNIQUE_CONTACTS');
    const requestData = {
      tags: payload.bulkIds.tags.join(),
      contacts: payload.bulkIds.contacts.join(),
      status: payload.status,
      channel: payload.channel,
    };
    api(
      'GET',
      `merchants/${payload.merchantId}/count-unique-contacts`,
      requestData,
    )
      .then((response) => {
        if (response.status === 200) {
          commit('SET_UNIQUE_CONTACTS_COUNT', response.data);
        }
      })
      .catch(() => {
        commit('SET_UNIQUE_ERROR');
      });
  },
  resetUniqueContactCount({ commit }) {
    commit('RESET_UNIQUE_CONTACT_COUNT');
  },
  exportContacts({ commit }, payload) {
    api(
      'POST',
      `/merchants/${payload.merchantId}/export-contacts`,
      payload.exportFilter,
    )
      .then((response) => {
        if (response.status === 200) {
          commit('SET_EXPORT_ID', response.data.export_id);
        }
      })
      .catch((error) => {
        commit('SET_EXPORT_ERROR', error.response.data.message);
        commit('API_ERROR', error.response);
      });
  },
  updateContactData({ commit }, payload) {
    commit('UPDATE_CONTACT_DATA', payload);
  },
  blockContact({ rootState }, payload) {
    const request = api('PUT', `organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.businessId}/conversation/${payload.conversationId}/block`, payload.data, null, 'w');
    return request;
  },
  setFilter({ rootState }, payload) {
    const requestType = payload.filterId ? 'PUT' : 'POST';
    const query = {
      query: payload.filterData,
    };
    const request = api(requestType, `organisation/${rootState.organisation.currentOrganisation.id}/contact/filter${payload.filterId ? `/${payload.filterId}` : ''}`, query, null, 'w');
    return request;
  },
};
